import { toast } from "react-toastify";

export const handleCustomResponse = (type, message) => {
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "info":
      toast.info(message);
      break;
    case "warning":
      toast.warn(message);
      break;
    default:
      toast(message);
  }
};

export const handleApiResponse = (
  res,
  message = "default message",
  method = ""
) => {
  method = method.toLowerCase();
  if (res?.success) {
    // toast.success(res?.message || message);
    if (method !== "get") {
      toast.success(res.message || message);
    }
  } else {
    if (method !== "get") {
      toast.error(res?.message || "Something went worng");
    }
  }
};
